import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assests/img/logo.png';

function Logo() {
  return (
    <Link to="/home" className="ma-logo-link" aria-label="MobileAcc Expo Home">
      <img className="ma-logo-img" src={logo} alt="MobileAcc Expo" />
    </Link>
  );
}

export default Logo;
